import { render, staticRenderFns } from "./GptChat.vue?vue&type=template&id=1904114e&scoped=true&%23chatSlot=true"
import script from "./GptChat.vue?vue&type=script&lang=js"
export * from "./GptChat.vue?vue&type=script&lang=js"
import style0 from "./GptChat.vue?vue&type=style&index=0&id=1904114e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904114e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
